import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Sarah M.', 'Jessica L.', 'Amanda K.', 'Maria R.', 'Emily T.', 'Rachel S.', 'Nicole P.', 'Olivia W.', 'Hannah B.'];
const LOCATIONS = ['New York', 'Los Angeles', 'Chicago', 'Miami', 'Austin', 'Seattle', 'Boston', 'Denver', 'Portland'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 3000);
    const interval = setInterval(() => {
      triggerNotification();
    }, 7000 + 4000); // Wait 7s + 4s duration
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
    setCurrentData({
      name: randomName,
      location: randomLocation
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-14">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 bg-stone-900 rounded-lg shadow-xl shadow-amber-500/20 p-4 max-w-xs z-40 border-l-4 border-amber-500 flex items-center gap-3" data-id="element-15">
          <div className="bg-amber-500/20 p-2 rounded-full border border-amber-500/30" data-id="element-16">
            <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-17" />
          </div>
          <div data-id="element-18">
            <p className="text-sm font-bold text-stone-100" data-id="element-19">
              {currentData.name}
            </p>
            <p className="text-xs text-stone-400" data-id="element-20">
              from {currentData.location}
            </p>
            <p className="text-xs text-amber-400 font-medium mt-0.5" data-id="element-21">
              Just purchased FLOW-4™
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}